module.exports = __webpack_public_path__ + "static/other/smallAliens.0917521a.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/smallAliens.json
// module id = 875
// module chunks = 0